import React from 'react';
import { ProductTileWrapper } from './Products.styled';
import { HashLink } from 'react-router-hash-link';

const ProductTile = ({ text, id, validated }) => {
  const url = validated ? `/pos/search/${id}` : `/pos/lookup/${id}`;

  return (
    <ProductTileWrapper rebrand>
      <HashLink to={url}>{text}</HashLink>
    </ProductTileWrapper>
  );
};

export default ProductTile;
